import { cx } from './cx';

export type StickerKind = 'star' | 'smile' | 'heart';
export const STICKERS: StickerKind[] = ['star', 'smile', 'heart'];

const TILE: Record<StickerKind, string> = { star: 'bg-coral-300', smile: 'bg-sage-200', heart: 'bg-lagoon-100' };

export const StickerIcon = ({ kind, size = 20 }: { kind: StickerKind; size?: number }) => (
  <svg aria-hidden="true" width={size} height={size} viewBox="0 0 24 24">
    {kind === 'star' && <path d="M12 2l2.9 6.9L22 9.3l-5.4 4.7L18.2 21 12 17.3 5.8 21l1.6-7L2 9.3l7.1-.4z" fill="#be123c" />}
    {kind === 'smile' && (
      <>
        <circle cx="12" cy="12" r="9" fill="#7c3aed" />
        <circle cx="9" cy="10" r="1.4" fill="#fff" />
        <circle cx="15" cy="10" r="1.4" fill="#fff" />
        <path d="M8.5 14c1.8 2 5.2 2 7 0" stroke="#fff" strokeWidth="1.8" fill="none" strokeLinecap="round" />
      </>
    )}
    {kind === 'heart' && <path d="M12 21 2.8 12A6 6 0 0 1 12 4.3 6 6 0 0 1 21.2 12z" fill="#2563eb" />}
  </svg>
);

/** One day in the sticker week: a sticker if the family did an activity, a dashed slot otherwise. */
export const StickerSlot = ({ kind, today = false, label }: { kind?: StickerKind; today?: boolean; label: string }) => (
  <span
    role="img"
    aria-label={label}
    className={cx(
      'flex aspect-square items-center justify-center rounded-[12px]',
      kind ? TILE[kind] : 'border-[1.5px] border-dashed border-[#D8C8AE]',
      today && !kind && 'border-coral-500',
    )}
  >
    {kind && <StickerIcon kind={kind} />}
  </span>
);
